const groupModules = {
  state: {
    groupList: [],
    currentGroupMemberList: [],
    count: 15,
    isLoading: false
  },
  getters: {
    hasGroupList: state => state.groupList.length > 0
  },
  mutations: {
    updateGroupList(state, groupList) {
      state.groupList = groupList;
    },
    updateCurrentGroupMemberList(state, groupMemberList) {
      state.currentGroupMemberList = [
        ...state.currentGroupMemberList,
        ...groupMemberList
      ];
    },
    resetGroup(state) {
      state.groupList = [];
      state.currentGroupProfile = {};
      state.currentGroupMemberList = [];
    },
    resetCurrentMemberList(state) {
      state.currentGroupMemberList = [];
    }
  },
  actions: {
    getGroupMemberList(context) {
      const {
        memberNum,
        groupID
      } = context.rootState.conversation.currentConversation.groupProfile;
      const { count, isLoading } = context.state;
      const offset = context.state.currentGroupMemberList.length;
      const notCompleted = offset < memberNum;
      if (notCompleted) {
        if (!isLoading) {
          context.state.isLoading = true;
          wx.$app
            .getGroupMemberList({ groupID, offset, count })
            .then(res => {
              context.commit(
                "updateCurrentGroupMemberList",
                res.data.memberList
              );
              context.state.isLoading = false;
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("你拉的太快了");
        }
      } else {
        console.log("没有更多啦");
      }
    }
  }
};

export default groupModules;
